export default {"src":"/_next/static/media/cxr3.320e23d2.svg","height":22,"width":13,"blurWidth":0,"blurHeight":0};